/**
 * Ora relativa unica per tutte le liste della chat (WhatsApp, Instagram, Messenger, "Tutte").
 * Prima ogni lista aveva il suo formato ("Ora"/"adesso", "5m"/"5 min") e nessuna si
 * aggiornava: un messaggio delle 17:30 restava "adesso" fino al ricaricamento.
 * Pura: il "now" arriva da fuori (useMinuteTick) cosi' si testa senza orologio.
 */
const MIN = 60 * 1000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export function chatRelativeTime(ts: number | string | Date | null | undefined, now: number): string {
  if (ts === null || ts === undefined || ts === '') return '';
  const date = ts instanceof Date ? ts : new Date(ts);
  const t = date.getTime();
  if (Number.isNaN(t)) return '';
  const diff = now - t;
  if (diff < MIN) return 'adesso';
  if (diff < HOUR) return `${Math.floor(diff / MIN)} min`;
  const today = startOfDay(new Date(now));
  if (t >= today) return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  if (t >= today - DAY) return 'ieri';
  if (t >= today - 6 * DAY) return date.toLocaleDateString('it-IT', { weekday: 'short' });
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
}

/** Data e ora complete, per il tooltip. */
export function chatExactTime(ts: number | string | Date | null | undefined): string {
  if (ts === null || ts === undefined || ts === '') return '';
  const date = ts instanceof Date ? ts : new Date(ts);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
}
